/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Page_Directory_TitleInputs */

const en_pricing_page_directory_title = /** @type {(inputs: Pricing_Page_Directory_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New clients without ads.`)
};

const pl_pricing_page_directory_title = /** @type {(inputs: Pricing_Page_Directory_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nowi klienci bez reklam.`)
};

/**
* | output |
* | --- |
* | "New clients without ads." |
*
* @param {Pricing_Page_Directory_TitleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const pricing_page_directory_title = /** @type {((inputs?: Pricing_Page_Directory_TitleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Page_Directory_TitleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_pricing_page_directory_title(inputs)
	return en_pricing_page_directory_title(inputs)
});